import { DateTime } from 'luxon';

export const ThityDaysAgo = (date: Date) =>
  DateTime.fromJSDate(date).minus({ days: 30 }).toJSDate();
